export enum DndDragItemTypes {
  ContentCalendarItem = 'ContentCalendarItem',
  ContentIdeaField = 'ContentIdeaField',
  Post = 'Post',
  Collection = 'Collection',
}
